import { ZonedDate } from '@progress/kendo-date-math';
/** @hidden */
export { MS_PER_DAY } from '@progress/kendo-date-math';
/** @hidden */
export var MIDNIGHT_INVARIANT = new Date(1980, 0, 1);
/** @hidden */
export var MS_PER_SECOND = 1000;
/** @hidden */
export var MS_PER_MINUTE = 60 * MS_PER_SECOND;
/** @hidden */
export var MS_PER_HOUR = 60 * MS_PER_MINUTE;
/** @hidden */
export var TIME_FORMAT = 't';
// probably should calculate this
/** @hidden */
export var BORDER_WIDTH = 1;
/** @hidden */
export var DEFAULT_EVENT_HEIGHT = 25;
/** @hidden */
export var DAYS_IN_WEEK_COUNT = 7;
/** @hidden */
export var WEEKS_COUNT = 6;
/** @hidden */
export var HOURS_IN_DAY_COUNT = 24;
/** @hidden */
export var EMPTY_RESOURCE = [{}];
/** @hidden */
export var OCCURRENCE_ID = 0;
/** @hidden */
export var DEFAULT_ID = undefined;
/** @hidden */
export var DISPLAY_NONE_STYLES = { display: 'none' };
/** @hidden */
export var VISIBILITY_HIDDEN_STYLES = { visibility: 'hidden' };
/** @hidden */
export var DEFAULT_GROUP = {
    index: 0,
    resources: []
};
/**
 * @hidden
 */
export var MIN_DATE = new Date(1900, 0, 1);
/**
 * @hidden
 */
export var MAX_DATE = new Date(2099, 11, 31);
/** @hidden */
export var DEFAULT_RANGE = {
    index: 0,
    start: MIN_DATE,
    end: MAX_DATE,
    zonedStart: ZonedDate.fromLocalDate(MIN_DATE),
    zonedEnd: ZonedDate.fromLocalDate(MAX_DATE)
};
//# sourceMappingURL=index.js.map